import { apiClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'
import type { ApiResponse, ItemCategory, ItemCategoryFormSavePayload, ItemSubCategory } from '@/api/types'

function unwrap<T>(payload: any): T {
  if (payload && typeof payload === 'object') {
    if ('success' in payload && 'data' in payload) return payload.data as T
    if ('data' in payload) return payload.data as T
  }
  return payload as T
}

function mapCategory(item: any): ItemCategory {
  const nameEn = String(
    item?.itemcategoryNameEn ??
      item?.itemCategoryNameEn ??
      item?.itemcategoryNameEN ??
      item?.itemCategoryNameEN ??
      ''
  )
  const nameAr = String(item?.itemcategoryNameAr ?? item?.itemCategoryNameAr ?? '')
  const isActive =
    item?.isActive !== undefined
      ? Boolean(item.isActive)
      : item?.active !== undefined
        ? Boolean(item.active)
        : undefined

  return {
    id: Number(
      item?.itemcategoryId ??
        item?.itemCategoryId ??
        item?.itemCategoryID ??
        item?.id ??
        item?.categoryId ??
        0
    ),
    name:
      nameEn ||
      nameAr ||
      String(item?.itemcategoryName ?? item?.itemCategoryName ?? item?.name ?? item?.categoryName ?? ''),
    nameEn: nameEn || undefined,
    nameAr: nameAr || undefined,
    isActive,
    branchId: item?.branchId !== undefined ? Number(item.branchId) : undefined,
  }
}

function mapSubCategory(item: any): ItemSubCategory {
  const nameEn = String(
    item?.subCategoryNameEn ??
      item?.SubCategoryNameEn ??
      item?.subcategoryNameEn ??
      item?.SubcategoryNameEn ??
      item?.name ??
      item?.Name ??
      item?.subCategoryName ??
      item?.SubCategoryName ??
      item?.subcategoryName ??
      ''
  )
  const nameAr = String(
    item?.subCategoryNameAr ??
      item?.SubCategoryNameAr ??
      item?.subcategoryNameAr ??
      item?.SubcategoryNameAr ??
      item?.nameAr ??
      item?.NameAr ??
      ''
  )
  const isActive =
    item?.isActive !== undefined
      ? Boolean(item.isActive)
      : item?.active !== undefined
        ? Boolean(item.active)
        : undefined
  const rawCategoryId = item?.categoryId ?? item?.CategoryId ?? item?.itemCategoryId ?? item?.itemcategoryId
  const rawBranchId = item?.branchId ?? item?.BranchId
  return {
    id: Number(
      item?.subCategoryId ??
        item?.SubCategoryId ??
        item?.subcategoryId ??
        item?.SubcategoryId ??
        item?.subCategoryID ??
        item?.SubCategoryID ??
        item?.subcategoryID ??
        item?.id ??
        item?.Id ??
        item?.ID ??
        0
    ),
    name: nameEn || nameAr || '',
    nameEn: nameEn || undefined,
    nameAr: nameAr || undefined,
    isActive,
    categoryId: rawCategoryId !== undefined ? Number(rawCategoryId) : undefined,
    branchId: rawBranchId !== undefined ? Number(rawBranchId) : undefined,
  }
}

export class ItemCategoriesService {
  async getAllItemCategories(branchId: number): Promise<ItemCategory[]> {
    const url = endpoints.itemCategories.getAll(branchId)
    const response = await apiClient.get<ApiResponse<any> | any>(url)
    const payload = unwrap<any>(response.data)
    const arr = Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(payload?.items)
          ? payload.items
          : []
    return arr.map(mapCategory).filter((c: ItemCategory) => c.id > 0)
  }

  async getSubCategoriesByCategoryId(catId: number): Promise<ItemSubCategory[]> {
    const url = endpoints.itemCategories.getSubCategoriesByCategoryId(catId)
    const response = await apiClient.get<ApiResponse<any> | any>(url)
    const payload = unwrap<any>(response.data)
    const arr = Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(payload?.items)
          ? payload.items
          : []
    return arr.map(mapSubCategory).filter((c: ItemSubCategory) => c.id > 0)
  }

  async formSave(payload: ItemCategoryFormSavePayload): Promise<void> {
    const url = endpoints.itemCategories.formSave
    await apiClient.post(url, payload)
  }
}

export const itemCategoriesService = new ItemCategoriesService()

